import React from "react";

const R = 120, C = 170;

export default function PieChartSvg({ data, total, colorOf }) {
  let acc = 0;
  const slices = data.map((d, i) => {
    const a0 = (acc / total) * 2 * Math.PI;
    acc += d.value;
    const a1 = (acc / total) * 2 * Math.PI;
    const p = (a) => [C + R * Math.sin(a), C - R * Math.cos(a)];
    const [x0, y0] = p(a0), [x1, y1] = p(a1);
    const large = a1 - a0 > Math.PI ? 1 : 0;
    const path = data.length === 1
      ? `M ${C} ${C - R} A ${R} ${R} 0 1 1 ${C - 0.01} ${C - R} Z`
      : `M ${C} ${C} L ${x0} ${y0} A ${R} ${R} 0 ${large} 1 ${x1} ${y1} Z`;
    const pct = (d.value / total) * 100;
    const [lx, ly] = [C + (R + 22) * Math.sin((a0 + a1) / 2), C - (R + 22) * Math.cos((a0 + a1) / 2)];
    return { ...d, i, path, pct, lx, ly };
  });
  return (
    <svg viewBox="-60 0 460 340" className="h-full w-full">
      {slices.map((s) => (
        <path key={s.name} d={s.path} fill={colorOf(s.name, s.i)} stroke="#fff" strokeWidth="1">
          <title>{`${s.name}: ${s.value} (${s.pct.toFixed(1)}%)`}</title>
        </path>
      ))}
      {slices.filter((s) => s.pct >= 3).map((s) => (
        <text key={s.name} x={s.lx} y={s.ly} fontSize="10" textAnchor={s.lx >= C ? "start" : "end"} fill="#334155">
          {`${s.name}: ${s.pct.toFixed(1)}%`}
        </text>
      ))}
    </svg>
  );
}
